import {IEventConfig} from '@mintdata/mint-kit/api/events/EventConfig';
import {EventPropName} from '@mintdata/mint-kit/api/events/EventType';

export class EventSpec implements IEventConfig
{
    constructor(public readonly eventPropertyName:EventPropName,
                public readonly isEnabled:boolean,
                public readonly title:string,
                public readonly tip:string,
                public readonly isHideOnPropertyPanel:boolean = false)
    {
    }
}
